__webpack_require__.p = "/dynamic-feature/referrals-hub/";